const PTAX_URL = 'https://olinda.bcb.gov.br/olinda/servico/PTAX/versao/v1/odata/CotacaoMoedaPeriodo(moeda=@moeda,dataInicial=@dataInicial,dataFinalCotacao=@dataFinalCotacao)';

interface PtaxResponse {
  value?: Array<{
    cotacaoVenda?: number;
    dataHoraCotacao?: string;
    tipoBoletim?: string;
  }>;
}

function ptaxDate(date: Date) {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${month}-${day}-${date.getFullYear()}`;
}

async function fetchPtax(currency: 'USD' | 'EUR', start: Date, end: Date) {
  // O serviço OData do BCB exige os nomes @moeda/@data... sem codificação.
  // URLSearchParams converte "@" para "%40" e o endpoint responde HTTP 400.
  const query = `@moeda='${currency}'&@dataInicial='${ptaxDate(start)}'&@dataFinalCotacao='${ptaxDate(end)}'&$orderby=dataHoraCotacao%20desc&$top=40&$format=json`;
  const response = await fetch(`${PTAX_URL}?${query}`, { cache: 'no-store' });
  if (!response.ok) throw new Error(`Falha ao consultar PTAX ${currency}: ${response.status}`);
  const data = await response.json() as PtaxResponse;
  // Cada dia tem vários boletins (Abertura, Intermediários e Fechamento). Vale o
  // Fechamento mais recente — o último valor do dia —, não um boletim intermediário.
  const latest = data.value?.find((item) => item.tipoBoletim === 'Fechamento') ?? data.value?.[0];
  if (!latest?.cotacaoVenda || latest.cotacaoVenda <= 0) throw new Error(`PTAX ${currency} indisponível`);
  return { value: latest.cotacaoVenda, sourceDate: latest.dataHoraCotacao || '' };
}

// A cotação usa o último valor (Fechamento PTAX) do dia anterior: consulta termina
// em "ontem", então segunda-feira pega o fechamento de sexta e feriado pega o último útil.
export async function fetchDailyExchangeRates() {
  const end = new Date();
  end.setDate(end.getDate() - 1);
  const start = new Date(end);
  start.setDate(start.getDate() - 10);
  const [usd, eur] = await Promise.all([fetchPtax('USD', start, end), fetchPtax('EUR', start, end)]);
  return {
    usd: usd.value,
    eur: eur.value,
    sourceDate: usd.sourceDate || eur.sourceDate,
  };
}

/** O valor guardado veio de hoje (regra antiga: boletim do próprio dia)? */
export function isRateFromToday(sourceDate?: string) {
  if (!sourceDate) return false;
  const now = new Date();
  const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
  return sourceDate.slice(0, 10) === today;
}

export function isSameLocalDay(isoDate?: string) {
  if (!isoDate) return false;
  const saved = new Date(isoDate);
  const now = new Date();
  return saved.getFullYear() === now.getFullYear()
    && saved.getMonth() === now.getMonth()
    && saved.getDate() === now.getDate();
}
